class NumberUtils {
  parseValidNonZero(value: string | number | null | undefined): number | null {
    const target = typeof value === "string" ? Number(value) : value;
    if (target == null || Number.isNaN(target) || target === 0) {
      return null;
    }

    return target;
  }
}

const numberUtils = new NumberUtils();
export default numberUtils;
